export default {
  legal: [
    {
      alias: "office-management",
      enableLinking: true,
      icon: "fas fa-users",
      title: "Office Management",
      lighter: "#FFF4ED",
      darker: "#FD8D4C",
      description:
        "Manage your team and departments. ClientGrid gives you the ability to manage an individual office or even multiple offices.",
      highlights: [
        {
          tagline: "Manage your teams and departments",
          title: "Organize your teams. ",
          description: [
            "Help your staff know exactly who is on which team and what they're responsible for.",
            "ClientGrid helps you grow your teams with clarity and ease."
          ],
          graphic:
            "https://drive.google.com/uc?id=12OvQ4QxP4y6nM_kajCKtJ_TKERzS0evf",
          screenshot:
            "https://drive.google.com/uc?id=1xdJvq2TmIFMaE8bfSC6aQpPozFlwo0yw"
        },
        {
          tagline: "Grow your team",
          title: "Invite staff members as you grow.",
          description: [
            'ClientGrid gives you the flexibility to define <a href="/features/roles&permissions">customizable permissions</a> down to every client and case sensitive information in our platform.',
            "We take attorney-client privilege seriously and give you the ability to set permissions that best suit your practice."
          ],
          graphic:
            "https://drive.google.com/uc?id=1H6faiv7SqyHm_tqZY3FNGoAnYFoIVm_Q",
          screenshot:
            "https://drive.google.com/uc?id=1nZSv4btC7KDdo1tRUj-y8GlAa9_gEAv2"
        },
        {
          tagline: "Get synced across offices",
          title: "Organize your offices.",
          description: [
            "Whether you need a solution for one office or multiple offices,",
            "ClientGrid was built for teams and organizations like yours."
          ],
          graphic:
            "https://drive.google.com/uc?id=1laHdsCq0mEjBn3oprl2-eF0ujUFu-tCT",
          screenshot:
            "https://drive.google.com/uc?id=19FjgiCKjpzZkQufp_2iGm8Noebo_B7WC"
        }
      ]
    },
    {
      alias: "case-management",
      enableLinking: true,
      icon: "fas fa-briefcase",
      title: "Case Management",
      lighter: "#fef5f8",
      darker: "#e75a8b",
      description:
        "Manage all your clients' cases in one place. Know exactly who was the last person on your team to communicate with them.",
      highlights: [
        {
          tagline: "Advanced search",
          title: "Find your clients case files quickly.",
          description: [
            "Quickly find your clients files and cases using our advanced search functionality.",
            "ClientGrid helps you quickly find what you're looking for."
          ],
          graphic:
            "https://drive.google.com/uc?id=1a-hqRyTNaD7threxvq4RcRFfkACgo11n",
          screenshot:
            "https://drive.google.com/uc?id=1oKv-d6gtKoyWTcqtNiI1T1ZLz64AVJl_"
        },
        {
          tagline: "Customizable Intake Forms",
          title: "Manage all your clients & cases in one platform.",
          description: [
            "Want to save yourself and your clients precious time?",
            "Send your custom-built intake form to your clients before their scheduled appointment, or embed your public intake forms on your website to capture more qualified leads."
          ],
          graphic:
            "https://drive.google.com/uc?id=1Ci-7hhRdkG8x8lhTWjjhlD0afPfnpbim",
          screenshot:
            "https://drive.google.com/uc?id=1nv04-ykLmFCzjG2EEakgHLtZrOdMFZRM"
        },
        {
          tagline: "Tags",
          title: "Assign tags and enhance your workflow.",
          description: [
            "Assign tags and create workflows that make it easy to stay on top of your case load.",
            "ClientGrid tags will help you take your level of organization to the next level."
          ],
          graphic:
            "https://drive.google.com/uc?id=1q6I9rHxHQmetbup91MffRYIPdmJu1LVd",
          screenshot:
            "https://drive.google.com/uc?id=1qi0roet0DIHiJ_C-b2FbX0YTKl6X8k1p"
        }
      ]
    },
    {
      alias: "documents",
      enableLinking: true,
      icon: "fas fa-file-alt",
      title: "Documents",
      lighter: "#F0F4FD",
      darker: "#6A92EE",
      description:
        "Keep your team in sync. Access all your teams' notes and client documents in one place. We even help you manage multiple versions of the same document.",
      highlights: [
        {
          tagline: "Integrations",
          title: "Sync and access all your documents securely.",
          description: [
            "Quickly access documents on desktop, mobile, or tablet. At the office or on the go",
            "ClientGrid supports integrations with Microsoft Office365, OneDrive, and SharePoint."
          ],
          graphic:
            "https://drive.google.com/uc?id=1mxzcouihHCTx-bHRbhjnDbBDpZ2DmDz0",
          screenshot:
            "https://drive.google.com/uc?id=1iWqdlJi_YIy9mrmw5ZuH35U9enC-bxlD"
        },
        {
          tagline: "Organize your documents",
          title: "Never lose a document again.",
          description: [
            "Ever get lost trying to find your clients documents?",
            "ClientGrid helps you organize all your clients' documents. You'll never be lost again. With our audit logs, you'll know exactly which documents were added and removed to a client's file."
          ],
          graphic:
            "https://drive.google.com/uc?id=13U-F08qgVo9x4ksAT3wFVtmu18QPSOTn",
          screenshot:
            "https://drive.google.com/uc?id=1iWqdlJi_YIy9mrmw5ZuH35U9enC-bxlD"
        }
      ]
    },
    {
      alias: "roles&permissions",
      enableLinking: true,
      icon: "fas fa-shield-alt",
      title: "Roles & Permissions",
      lighter: "#FFF5F8",
      darker: "#F74E8C",
      description:
        "Create different roles for your team (attorneys, paralegals, & interns). Give each role customizable permissions.",
      highlights: [
        {
          tagline: "Customizable control access",
          title: "Roles allow you to define who has access.",
          description: [
            "ClientGrid gives you the flexibility to define customizable permissions down to every client and case sensitive information in our platform.",
            "We take attorney-client privilege seriously and give you the ability to set permissions that best suit your practice."
          ],
          graphic:
            "https://drive.google.com/uc?id=1BcTpnPmYAPvxQPaS3OZbTTqdv1SiYMOc",
          screenshot:
            "https://drive.google.com/uc?id=1mtw-dKK7Zx6dBnic0Gh7g32b_EcYck20"
        },
        {
          tagline: "Assign staff",
          title: "Know who's working on what.",
          description: [
            "We've made it simple for you to know who's assigned to which cases.",
            "Delegation & task management built in."
          ],
          graphic:
            "https://drive.google.com/uc?id=1KBAT2LX_cvVVPuet-oi8IWh2jrV8mc6e",
          screenshot:
            "https://drive.google.com/uc?id=1hhR2PPNHG2mUZASNGLcBfHcLxW6fv0Rh"
        }
      ]
    },
    {
      alias: "attorney-client-privilege",
      enableLinking: true,
      icon: "fas fa-user-shield",
      title: "Attorney-Client Privilege",
      lighter: "#f5fbf6",
      darker: "#5ac063",
      description:
        "ClientGrid allows you to restrict who in your office or team can see sensitive data, notes, and documents.",
      highlights: [
        {
          tagline: "Private Notes & Documents",
          title: "Preserve attorney-client privelege.",
          description: [
            "You can choose to lock down sensitive client information to only be seen by those assigned to a case.",
            "All notes, documents, and even contact information can be secured by making it private to only those who should have access in your office."
          ],
          graphic:
            "https://drive.google.com/uc?id=1ur0H6NTcvmSvuX3_mfQMnEAOum2i3V2k",
          screenshot:
            "https://drive.google.com/uc?id=1Wlgg6VsG-F9FF1sverao9PmFB6otQLWC"
        },
        {
          tagline: "Customizable control access",
          title: "Roles allow you to define who has access.",
          description: [
            "ClientGrid gives you the flexibility to define customizable permissions down to every client and case sensitive information in our platform.",
            "We take attorney-client privilege seriously and give you the ability to set permissions that best suit your practice."
          ],
          graphic:
            "https://drive.google.com/uc?id=1BcTpnPmYAPvxQPaS3OZbTTqdv1SiYMOc",
          screenshot:
            "https://drive.google.com/uc?id=1mtw-dKK7Zx6dBnic0Gh7g32b_EcYck20"
        }
      ]
    },
    {
      alias: "security",
      enableLinking: true,
      icon: "fas fa-lock",
      title: "Security",
      lighter: "#F3F0FF",
      darker: "#8666FA",
      description:
        "We've built ClientGrid to be fully encrypted to secure sensitive client data. We take security very seriously.",
      highlights: [
        {
          tagline: "Private Notes & Documents",
          title: "Preserve attorney-client privelege.",
          description: [
            "You can choose to lock down sensitive client information to only be seen by those assigned to a case.",
            "All notes, documents, and even contact information can be secured by making it private to only those who should have access in your office."
          ],
          graphic:
            "https://drive.google.com/uc?id=1ur0H6NTcvmSvuX3_mfQMnEAOum2i3V2k",
          screenshot:
            "https://drive.google.com/uc?id=1Wlgg6VsG-F9FF1sverao9PmFB6otQLWC"
        },
        {
          tagline: "Customizable control access",
          title: "Roles allow you to define who has access.",
          description: [
            "ClientGrid gives you the flexibility to define customizable permissions down to every client and case sensitive information in our platform.",
            "We take attorney-client privilege seriously and give you the ability to set permissions that best suit your practice."
          ],
          graphic:
            "https://drive.google.com/uc?id=1BcTpnPmYAPvxQPaS3OZbTTqdv1SiYMOc",
          screenshot:
            "https://drive.google.com/uc?id=1mtw-dKK7Zx6dBnic0Gh7g32b_EcYck20"
        }
      ]
    },
    {
      alias: "custom-intake-forms",
      enableLinking: true,
      icon: "fas fa-check-square",
      title: "Custom Intake Forms",
      lighter: "#F0F4FD",
      darker: "#6A92EE",
      description:
        "Our easy to use form builder helps you get the information you need from clients. We also have dedicated servers that host forms for you and allow you to embed directly on your website.",
      highlights: [
        {
          tagline: "Embeddable Forms",
          title: "Embed your ClientGrid intake forms directly on your website.",
          description: [
            "Want to save yourself and your clients precious time?",
            "Send your custom-built intake form to your clients before their scheduled appointment, or embed your public intake forms on your website to capture more qualified leads."
          ],
          graphic:
            "https://drive.google.com/uc?id=1Ci-7hhRdkG8x8lhTWjjhlD0afPfnpbim",
          screenshot:
            "https://drive.google.com/uc?id=1nv04-ykLmFCzjG2EEakgHLtZrOdMFZRM"
        },
        {
          tagline: "Custom Form Builder",
          title: "Our beautifully designed form builder makes it simple.",
          description: [
            "Easy to use and fully customizable intake forms are minutes away, including email, phone, and address validation.",
            "Create, edit, and send unlimited intake forms with our drag and drop form builder. Clients submit intake forms on your website, all the information automatically goes into ClientGrid."
          ],
          graphic:
            "https://drive.google.com/uc?id=1w6fVH_N_inWFCIjry_LPzRbNhCA6LtMe",
          screenshot:
            "https://drive.google.com/uc?id=15elqz33rhaQiWVmwXultrVgC1rlO0k9n"
        }
      ]
    },
    {
      alias: "time-tracking",
      enableLinking: false,
      icon: "fas fa-clock",
      title: "Time Tracking",
      lighter: "#F0F4FD",
      darker: "#3e3e3e",
      description:
        "For most business 30% of billable time is lost due to no clear timekeeping system. ClientGrid has an easy to use solution for keeping track of the time your legal team spends on case work."
    },
    {
      alias: "invoicing",
      enableLinking: false,
      icon: "fas fa-receipt",
      title: "Invoicing",
      lighter: "#F0F4FD",
      darker: "#3e3e3e",
      description:
        "Stay organized, keep track of billable hours, and easily print or email clients invoices for the work you and your team have done."
    }
  ],
  insurance: [
    {
      icon: "fa-users",
      title: "Office Management",
      description:
        "Manage your team and office(s). ClientGrid gives you the ability to manage an individual office or even multiple offices."
    },
    {
      icon: "fa-address-book",
      title: "Client Management",
      description:
        "Know when clients called and when your team last communicated with any client."
    },
    {
      icon: "fa-briefcase",
      title: "Policy Management",
      description:
        "Manage all your clients' policies in one place. Know exactly who was the last person on your team to communicate with them."
    },
    {
      icon: "fas fa-shield=alt",
      title: "Roles & Permissions",
      description:
        "Create different roles for your team (sales agents, underwriters, & customer service reps). Give each role customizable permissions."
    },
    {
      icon: "fas fa-file-alt",
      title: "Notes & Documents",
      description:
        "Keep your team in sync. Access all your teams' notes and client documents in one place. We even help you manage multiple versions of the same document."
    }
  ]
};
